import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Leaf } from "lucide-react";

export function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-50">
        <Leaf className="w-8 h-8 text-emerald-800 animate-pulse" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    const home = user.role === "grocery_store" ? "/store" : user.role === "aid_organization" ? "/organization" : "/admin";
    return <Navigate to={home} replace />;
  }
  return children;
}
